import { Divider, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { ReactComponent as MediaIcon } from 'assets/icons/edit-image.svg';
import { ReactComponent as EditIcon } from 'assets/icons/edit-white.svg';
import { DrawerMedia, GridWrap, InfoWrapper, Table } from 'components';
import { FieldType, MediaGroup, UploadMedia } from 'constants/inspections';
import {
  geometriaSezioneControventoOptions,
  tipologiaControventoOptions,
} from 'constants/selectOptions';
import { useInspectionPath } from 'hooks';
import { INFO } from 'pages/Inspections/config/info';
import { useInspectionSelector } from 'stores';
import ControventiForm from './ControventiForm';

const ControventiSection = ({ selectedIdx }) => {
  const { watch, setValue, getValues } = useFormContext();
  const { inspectionDisabled } = useInspectionSelector();
  const { isViewingInspection } = useInspectionPath();

  const mensoleTamponiCampateImpalcatoTableControventiTableWatch = watch(
    `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].controventiTable`
  );

  // table setup
  const dataConfigControventi = {
    columns: {
      codice: { label: 'Codice' },
      tipologiaControvento: {
        label: 'Tipologia',
        format: tipologiaControventoOptions,
      },
      geometriaSezioneControvento: {
        label: 'Geometria sezione',
        format: geometriaSezioneControventoOptions,
      },
      lunghezzaControvento: {
        label: 'L [cm]',
      },
      diametroControvento: {
        label: 'D [cm]',
      },
      spessoreControvento: {
        label: 's [cm]',
      },
      altezzaControvento: {
        label: 'H [cm]',
      },
      superficieControvento: {
        label: 'Sup. [m²]',
        formatValue: val => `${(+val)?.toFixed(2)}`,
      },
    },
  };

  // controventi setup
  const [selectedControventi, setSelectedControventi] = useState([]);
  const [open, setOpen] = useState(false);
  const [drawerMediaIndex, setDrawerMediaIndex] = useState();

  const editRowsControventi = item => {
    setValue('l0t2a5_controventiTableValue', [item]);
    setValue(
      'l0t2a5_tipologiaControventoTableValue',
      item.tipologiaControvento
    );
    setValue(
      'l0t2a5_geometriaSezioneControventoTableValue',
      item.geometriaSezioneControvento
    );
    setValue(
      'l0t2a5_lunghezzaControventoTableValue',
      item.lunghezzaControvento
    );
    setValue('l0t2a5_diametroControventoTableValue', item.diametroControvento);
    setValue('l0t2a5_spessoreControventoTableValue', item.spessoreControvento);
    setValue('l0t2a5_altezzaControventoTableValue', item.altezzaControvento);
    setValue(
      'l0t2a5_superficieControventoTableValue',
      item.superficieControvento
    );
  };
  const handleSelectAllClickControventi = event => {
    if (event.target.checked) {
      const selectedValue = getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].controventiTable`
      );
      setSelectedControventi(selectedValue);
      setValue('l0t2a5_controventiTableValue', selectedValue);
    } else {
      setSelectedControventi([]);
      setValue('l0t2a5_controventiTableValue', []);
    }
  };

  return (
    <>
      <GridWrap container spacing={2} style={{ marginTop: 16 }}>
        <InfoWrapper
          isDivider={true}
          size={12}
          infoDrawer={true}
          drawerTitle={INFO.impalcatoControventi.drawerTitle}
          drawerText={INFO.impalcatoControventi.drawerText}
        >
          <Divider>CONTROVENTI</Divider>
        </InfoWrapper>
        {mensoleTamponiCampateImpalcatoTableControventiTableWatch?.length ===
          0 && (
          <GridWrap item xs={12} paddingTop={'0px !important'}>
            <Typography>
              Nessun controvento presente in questo elemento
            </Typography>
          </GridWrap>
        )}
      </GridWrap>
      {mensoleTamponiCampateImpalcatoTableControventiTableWatch?.length > 0 && (
        <>
          {!inspectionDisabled && !isViewingInspection && (
            <ControventiForm
              controventiFields={
                mensoleTamponiCampateImpalcatoTableControventiTableWatch || []
              }
              selected={selectedControventi}
              setSelected={setSelectedControventi}
              controventiTable={`mensoleTamponiCampateImpalcatoTable[${selectedIdx}].controventiTable`}
              selectedIdx={selectedIdx}
            />
          )}
          <DrawerMedia
            open={open}
            setOpen={setOpen}
            title={'Traversi'}
            infoPanel="Per un'ottimizzazione nel report, si consiglia di eseguire foto in orizzontale in rapporto 4:3."
            dataType="video/*,image/*"
            uploadType={UploadMedia.media}
            type={FieldType.images}
            formName={`mensoleTamponiCampateImpalcatoTable[${selectedIdx}].controventiTable[${drawerMediaIndex}].media`}
            mediaGroup={[MediaGroup.Struttura]}
          />
          <GridWrap container spacing={2} mt={2}>
            <GridWrap item xs={12}>
              <Table
                data={
                  mensoleTamponiCampateImpalcatoTableControventiTableWatch || []
                }
                config={dataConfigControventi}
                hasCheckbox={!inspectionDisabled && !isViewingInspection}
                rowActions={
                  !inspectionDisabled && !isViewingInspection
                    ? [
                        {
                          onClick: item => {
                            editRowsControventi(item);
                            setSelectedControventi([item]);
                          },
                          icon: <EditIcon />,
                        },
                      ]
                    : []
                }
                mediaActions={[
                  {
                    onClick: item => {
                      setDrawerMediaIndex(
                        mensoleTamponiCampateImpalcatoTableControventiTableWatch.findIndex(
                          el => el.id === item.id
                        )
                      );
                      setOpen(true);
                    },
                    icon: <MediaIcon />,
                  },
                ]}
                selected={selectedControventi}
                onSelectAllClick={handleSelectAllClickControventi}
                setSelected={setSelectedControventi}
              />
            </GridWrap>
          </GridWrap>
        </>
      )}
    </>
  );
};
ControventiSection.propTypes = {
  selectedIdx: PropTypes.number,
};
export default ControventiSection;
